import CisionOwnershipPage from './CisionOwnershipPage';

export default CisionOwnershipPage;
